interface IPushRegistrationEventProps {
  method: string;
}

export function pushRegistrationEvent({ method }: IPushRegistrationEventProps) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "sign_up",
      method,
      domain: "Nju",
    });
  }
}
